<template>
  <div class="bg">
    <!-- <img src="./img/a.png" alt="" width="100%"> -->
    <div v-if="!+ifActive" class="customer">
      <div style="margin-top: 30%" class="title">来晚一步<br/>问卷已经结束收集咯！</div>
    </div>
    <div class="customer">
      <!-- <div class="title" style="color: bule;">学生健康征询单</div> -->
      <div class="title">{{ customerPaper.name }}</div>
      <div class="subtitle">{{ customerPaper.description }}</div>
      <el-form
        class="questions"
        ref="customerForm"
        :model="customerPaper"
        label-position="top"
      >
        <div
          v-for="(question, index) in customerPaper.healthList"
          :key="question.id"
        >
          <el-divider v-if="index !== 0"></el-divider>
          <el-form-item
            style="text-align: left;"
            :rules="rules[question.type]"
            required
          >
            <span slot="label" class="questionTitle">
              问题 {{ index + 1 }}：{{ question.title }}
              <el-tag size="mini">{{ ['','单选题','多选题','','','简答题'][question.type] }}</el-tag>
            </span>


            <el-input

              v-if="+question.type == 5"
              style="width: 80%;"
              type="textarea"
              size="mini"
              rows="4"
              v-model="question.value[0]"
            ></el-input>

            <el-radio-group
              v-else-if="+question.type == 1"
              v-model="question.value[0]"
              size="mini"
              style="display: flex;flex-wrap: wrap;"
            >
              <div
                v-for="(option,i) in question.childList"
                :key="i"
                style="margin-right: 8px"
              >
                <el-radio 
                  :label="option.value" 
                  border
                >
                  {{option.value}}
                </el-radio>
              </div>
            </el-radio-group>


            <el-checkbox-group
              v-if="+question.type == 2"
              v-model="question.value"
              size="mini"
              style="display: flex;flex-wrap: wrap;"
            >
              <div
                v-for="(option,i) in question.childList"
                :key="i"
                style="margin-right: 8px"
              >
                <el-checkbox :label="option.value" 
                  border
                >{{option.value}}</el-checkbox>
              </div>
            </el-checkbox-group>
          </el-form-item>
        </div>

        <el-form-item>
          <el-button type="primary" v-if="!+customerPaper.type" size="large" style="width: 100%;margin:0px auto;" @click="submitAnswer()"
            >完成填写！</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import Question from './components/CustomerQuestion'
import { getHealthTestStart,getHealthListBySnCode} from "@/api/surveyMgt.js";

export default {
  name: 'Customer',
  data() {
    const rules = {
      1: [
        {  required: true, trigger: 'change', message: '必须选择一个' }
      ],
      2: [
        { type: 'array', required: true, trigger: 'change', message: '多选至少选一个' }
      ],
      3: [
        { required: true, trigger: 'blur', message: '输入不可为空' }
      ],
      5: [
        { required: true, trigger: 'blur', message: '输入不可为空' }
      ]
    }
    return {
      ifActive: 1,
      rules,
      paperId: -1,
      customerPaper:{
        title:'title',
        description:'description',
        
      healthList:[]

      },
    }
  },
  mounted() {
    console.log(JSON.parse(this.$route.query.data));
    this.customerPaper = JSON.parse(this.$route.query.data)
    this.ifActive = +this.customerPaper.ifActive
    this.customerPaper?.healthList?.forEach(el=>{

      if (el.value == null) {
          this.$set(el, 'value', [])
        }
      if (el.type == 1) {
        console.log(el.value,el.childList[0].value);
        
        if (el.value.length == 0) {
          el.value[0] = el.childList[0].value
        }
        
      }
      if (el.type == 2) {
        if (el.value == null) {
          this.$set(el, 'value', [])
        }
        
      }

    })

    this.paperId = this.$route.params.paperId

    // console.log(`paperId: ${this.paperId}`)
    this.init()
  },
  computed: {
 
  },
  methods: {
    init(){
      // getHealthListBySnCode({snCode:}).then(res=>{

      // })
    },
    submitAnswer(){ 
     this.$refs.customerForm.validate(async valid => {
      console.log(this.customerPaper);
      let query =  JSON.parse(this.$route.query.data)
      console.log(query,JSON.parse(this.$route.query.data));
      
      if (!valid) {
        return
      }
      this.$dialog
        .alert({
          title:'提示',
          message: '是否确认提交?',
          showCancelButton: true
        })
        .then(() => {


          let data = {
        healthId:  JSON.parse(this.$route.query.data).id,
        snCode:  JSON.parse(this.$route.query.data).snCode,
        termCode:  JSON.parse(this.$route.query.data).termCode,
        studentName:  JSON.parse(this.$route.query.data).studentName,
        schoolCode:  JSON.parse(this.$route.query.data).schoolCode,
        
        termName:  JSON.parse(this.$route.query.data).termName,
        healthList: this.customerPaper.healthList
      }
      getHealthTestStart(data).then(res=>{
        console.log(res)
          this.$message({
            type: 'success',
            message: '提交成功'
          })
        this.$router.back(-1)

      })
        })
        .catch(() => {
          // on cancel
        })


    })
   
    }
  }
}
</script>

<style>
.bg {
  width: 100vw;
  min-height: 100vh;
  background: #efefef;
}

.customer {
  box-sizing: border-box;
  padding-top: 40px;
  background: white;
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  overflow: scroll;
}

.customer > .title {
  text-align: center;
  font-size: 30px;
}
.customer > .subtitle {
  font-size: 20px;
  width: 80%;
  margin: 20px auto;
  text-indent: 2em;
  text-align: left;
}

.customer > .questions {
  margin: 0 10%;
}

.questionTitle {
  font-size: 20px;
}
</style>
